import React from "react";
import { routes } from "../../../../constants";
import { StaffDashboard } from "../../../../component/pages/staff";
import { Navigate, Route } from "react-router-dom";
import userLayouts from "../../../../constants/userLayoutsConsts";
import { baseRouteMaker } from "../../../../constants/routeConsts";
import { StaffAppointmentInfo } from "../../../../component/pages/staff/modules/staff-appointment-info";

const renderStaffProtectedRoutes = ({ layout }) => {
  switch (layout) {
    case userLayouts.IS_AUTH:
      return <></>;

    case userLayouts.IS_MAIN:
      return (
        <>
          <Route path={routes.STAFF_DASHBOARD} element={<StaffDashboard />} />

          {/* Appointment module routes */}
          <Route
            path={routes.STAFF_APPOINTMENT}
            element={
              <Navigate to={baseRouteMaker(routes.STAFF_CALENDAR)} replace />
            }
          />

          <Route
            path={routes.STAFF_APPOINTMENT_INFO}
            element={<StaffAppointmentInfo />}
          />
        </>
      );
  }
};

export default renderStaffProtectedRoutes;
